import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
export var SET_LAYER_PRODUCTS = 'SET_LAYER_PRODUCTS';
export var RESET_LAYER_PRODUCTS = 'RESET_LAYER_PRODUCTS';
export var SET_LOADING_LAYER = 'SET_LOADING_LAYER';
export var SET_CURRENT_LAYER = 'SET_CURRENT_LAYER';
export var APPEND_ITEMS = 'APPEND_ITEMS';